import React from 'react';
import PropTypes from 'prop-types';

import { Typo } from 'uikit/content';

const VersioningPropertiesBoolean = ({ value = null, options = [] }) => (
  <Typo color="secondary" variant="b01">
    {options.find((option) => option.value === value)?.label || value}
  </Typo>
);

VersioningPropertiesBoolean.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number]),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number]),
    }),
  ),
};

export default React.memo(VersioningPropertiesBoolean);
